import { render, staticRenderFns } from "./Muestras.vue?vue&type=template&id=6025fb49&scoped=true"
import script from "./Muestras.vue?vue&type=script&lang=js"
export * from "./Muestras.vue?vue&type=script&lang=js"
import style0 from "./Muestras.vue?vue&type=style&index=0&id=6025fb49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025fb49",
  null
  
)

export default component.exports